export function calculatePayment(loanAmount, monthlyRate, numberOfPayments) {
  return (
    loanAmount *
    ((monthlyRate * Math.pow(1 + monthlyRate, numberOfPayments)) /
      (Math.pow(1 + monthlyRate, numberOfPayments) - 1))
  );
}

export default calculatePayment;
